import React from 'react';

const Refund = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Return, Refund and Cancellation Policy</h1>
          <p className="text-gray-600">Last updated: March 28, 2024</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-6">
            Thank you for shopping at Aashritha E Solutions website and Jewellery App.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Refund Policy</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            <strong>All sales are final and no refunds will be issued.</strong>
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Shipping & Delivery Policy</h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Shipping is not applicable for business.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            If you have any questions about this Return, Refund and Cancellation Policy, please contact us:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-700">
            <li>By email: aashritha756@yahoo.com</li>
            <li>By phone: +91 9448128756</li>
          </ul>
        </div>
      </div>
    </div>
  );
};


export default Refund;
